class bdSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.flickity = null;
  }

  connectedCallback() {
    this.slider = this.querySelector('.bd-slider');
    if (!this.slider) {
      console.warn('No .bd-slider found inside <bd-slider>');
      return;
    }

    const dataset = this.slider.dataset;
    const autoplayMs = dataset.autoplay ? parseInt(dataset.autoplay) : 0;
    console.log(autoplayMs, 'Autoplay Speed');
    const navfor = dataset.navFor
      ? document.querySelector(dataset.navFor)
      : false;


    // Remove hidden or empty cells before initializing Flickity
// Remove <style> and <script> elements from the slider
this.slider.querySelectorAll(':scope > style, :scope > script').forEach(el => el.remove());
 
    this.flickity = new Flickity(this.slider, {
      prevNextButtons: dataset.arrows === 'true',
      pageDots: dataset.dots === 'true',
      adaptiveHeight: dataset.adaptiveHeight === 'true',
      asNavFor: navfor,
      freeScroll: dataset.freeScroll === 'true',
      wrapAround: dataset.wrapAround === 'true',
      fade: dataset.fade === 'true',
      initialIndex: dataset.initialIndex || 0,
      autoPlay: dataset.autoplay ? parseInt(dataset.autoplay) : 0,
      cellAlign: dataset.cellAlign || 'left',
      watchCSS: dataset.watchCss === 'true',
      groupCells: true,
      contain: true,
      percentPosition: false,
      imagesLoaded: true,
      on: {
        ready: function () {
          const flkty = this;
          const slideCount = flkty.slides.length;
          if (slideCount <= 1) {
            flkty.element.removeAttribute('tabindex');
            flkty.element.removeAttribute('aria-label');
            flkty.prevButton?.element.classList.add('visually-hidden');
            flkty.nextButton?.element.classList.add('visually-hidden');
            flkty.pageDots?.element.classList.add('visually-hidden');
          }
          if (flkty.options.fade) {
            flkty.fadeIndex = flkty.selectedIndex;
            flkty.prevSelectedIndex = flkty.selectedIndex;
            flkty.on('select', flkty.onSelectFade);
            flkty.on('dragEnd', flkty.onDragEndFade);
            flkty.on('settle', flkty.onSettleFade);
            flkty.on('activate', flkty.onActivateFade);
            flkty.on('deactivate', flkty.onDeactivateFade);
          }
        },
      },
    });
    if (autoplayMs > 0) {
      this.injectAutoplayToggle();
    }
    this.setupCustomPagination();
  }

  injectAutoplayToggle() {
    const wrapper = this;
    const prevArrow = wrapper.querySelector('.prev-arrow');
    if (!prevArrow) return;

    const toggleBtn = document.createElement('button');
    const playBtn =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-play" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/></svg>';
    const pauseBtn =
      '<svg class="icon icon-pause" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><path d="M1.2 0.75C0.813401 0.75 0.5 0.985051 0.5 1.275V10.725C0.5 11.0149 0.813401 11.25 1.2 11.25C1.5866 11.25 1.9 11.0149 1.9 10.725V1.275C1.9 0.985051 1.5866 0.75 1.2 0.75Z" fill="currentColor"/><path d="M6.8 0.75C6.4134 0.75 6.1 0.985051 6.1 1.275V10.725C6.1 11.0149 6.4134 11.25 6.8 11.25C7.1866 11.25 7.5 11.0149 7.5 10.725V1.275C7.5 0.985051 7.1866 0.75 6.8 0.75Z" fill="currentColor"/></svg>';

    toggleBtn.className = 'autoplay-toggle';
    toggleBtn.setAttribute('aria-label', 'Pause autoplay');
    toggleBtn.innerHTML = pauseBtn; // You can swap this for an SVG or icon

    const visuallyHiddenText = document.createElement('span');
    visuallyHiddenText.className = 'visually-hidden';
    visuallyHiddenText.textContent = 'This button toggles autoplay on and off';
    toggleBtn.appendChild(visuallyHiddenText);

    let isPaused = false;

    toggleBtn.addEventListener('click', () => {
      if (isPaused) {
        this.flickity.playPlayer();
        toggleBtn.innerHTML = pauseBtn;
        toggleBtn.setAttribute('aria-label', 'Pause autoplay');
      } else {
        this.flickity.stopPlayer();
        toggleBtn.innerHTML = playBtn;
        toggleBtn.setAttribute('aria-label', 'Resume autoplay');
      }
      isPaused = !isPaused;
    });

    prevArrow.parentNode.insertBefore(toggleBtn, prevArrow);
  }

  setupCustomPagination() {
    if (!this.slider.hasAttribute('data-custom-pag')) {
      console.log('Custom pagination NOT enabled — exiting setup');
      return;
    }

    console.log('✅ Custom pagination setup triggered for:', this.slider);

    const wrapper = this;
    const flkty = this.flickity;

    const customPrev = wrapper.querySelector('.prev-arrow');
    const customNext = wrapper.querySelector('.next-arrow');
    const customPrevText = wrapper.querySelector('[data-prev-text]');
    const customNextText = wrapper.querySelector('[data-next-text]');

    const toggleCustomControls = () => {
      const shouldHide = !flkty.isActive || flkty.slides.length <= 1;

      customPrev?.classList.toggle('visually-hidden', shouldHide);
      customNext?.classList.toggle('visually-hidden', shouldHide);
      customPrevText?.classList.toggle('visually-hidden', shouldHide);
      customNextText?.classList.toggle('visually-hidden', shouldHide);
    };

    // Wait for Flickity to finish layout
    flkty.on('ready', toggleCustomControls);
    flkty.on('settle', toggleCustomControls);
    flkty.on('resize', toggleCustomControls);

    console.log(wrapper, 'WRAPPER');
    wrapper.addEventListener('click', (e) => {
      console.log(e, 'EVENT ON SLIDER CLICK NEXT PREV');
      const nextBtn = e.target.closest('.next-arrow');
      const prevBtn = e.target.closest('.prev-arrow');
      if (nextBtn) this.flickity.next();
      if (prevBtn) this.flickity.previous();
    });

    const updateStatus = () => {
      const prevArrow = wrapper.querySelector('.prev-arrow');
      const nextArrow = wrapper.querySelector('.next-arrow');

      if (this.flickity.options.wrapAround) {
        //prevArrow?.classList.remove('disabled');
        //nextArrow?.classList.remove('disabled');
        return;
      }

      const cellNumber = this.flickity.selectedIndex + 1;
      const totalSlides = this.flickity.slides.length;

      //prevArrow?.classList.toggle('disabled', cellNumber === 1);
      //nextArrow?.classList.toggle('disabled', cellNumber === totalSlides);
    };

    const updatePagNames = (index) => {
      const size = this.flickity.cells.length;
      const getSlide = (i) => this.slider.querySelector(`[data-index="${i}"]`);

      const currentIndex = this.flickity.selectedIndex;
      const nextIndex = currentIndex < size - 1 ? currentIndex + 1 : 0;
      const prevIndex = currentIndex > 0 ? currentIndex - 1 : size - 1;

      const nextSlide = getSlide(nextIndex);
      const prevSlide = getSlide(prevIndex);

      const nextTitle = nextSlide?.dataset.title || '';
      const prevTitle = prevSlide?.dataset.title || '';

      const nextText = wrapper.querySelector('[data-next-text]');
      const prevText = wrapper.querySelector('[data-prev-text]');

      if (nextText) nextText.innerHTML = nextTitle;
      if (prevText) prevText.innerHTML = prevTitle;
    };

    this.flickity.on('select', () => {
      this.flickity.slides.forEach((slide, index) => {
        const cell = this.flickity.cells[index].element;
        cell.setAttribute(
          'aria-hidden',
          index === this.flickity.selectedIndex ? 'false' : 'true'
        );
        cell.setAttribute(
          'tabindex',
          index === this.flickity.selectedIndex ? '0' : '-1'
        );
      });
    });

    this.flickity.on('settle', () => {
      this.slider.classList.toggle(
        'on-last',
        this.flickity.selectedIndex === this.flickity.slides.length - 1
      );
    });

    this.flickity.on('change', (index) => {
      updatePagNames(index);
    });

    updatePagNames(0);
    updateStatus();
  }
}

customElements.define('bd-slider', bdSlider);
